import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeOldDrugIngredient } from "../Entity/TreeNodeOldDrugIngredient";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeOldDrugIngredientsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Old Drug Ingredients ({param})');
      this.labelNodeName = 'Old drug Ingredients';
      this.parent = parent;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
      if (this.parent) {
        (this.parent as Art57Node).refreshLabel();
      }
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodeOldDrugIngredient(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }

    override getMessage(): any {
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Role', 'Full Description'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeOldDrugIngredientsList =
        new TreeNodeOldDrugIngredientsList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
  }